import { render, staticRenderFns } from "./PortfolioContainer.vue?vue&type=template&id=2bbd90f6&scoped=true&"
import script from "./PortfolioContainer.vue?vue&type=script&lang=js&"
export * from "./PortfolioContainer.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioContainer.vue?vue&type=style&index=0&id=2bbd90f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd90f6",
  null
  
)

export default component.exports